import React from "react";
import { Link } from "react-router-dom";
import Dashboard from "./Dashboard";

export default function Bienvenida() {
  const hoy = new Date();
  const labelMes = hoy.toLocaleString("es-MX", { month: "long", year: "numeric" });
  const hoyISO = hoy.toISOString().slice(0, 10);

  return (
    <div className="max-w-5xl mx-auto py-10 px-4">
      <div className="bg-white rounded-2xl shadow p-8 border-t-4 border-worthgold">
        <h1 className="text-3xl font-extrabold text-worthblue mb-2">¡Bienvenido a Worth Pagos!</h1>
        <p className="text-gray-600">Elige una sección para comenzar. Mes actual: <b>{labelMes}</b></p>

        <div className="mt-6">
          <Dashboard mes={hoy.getMonth()} anio={hoy.getFullYear()} />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-6">
          <Card link={`/calendario?vista=mensual&dia=${hoyISO}`} title="Calendario" desc="Pagos por día, totales semanales y del mes." btn="Ver hoy" />
          <Card link="/captura" title="Captura" desc="Agrega gastos (cuentas, OS, categorías)." btn="Capturar" />
          <Card link="/proyeccion" title="Proyección" desc="Barras apiladas por quincena/mes." btn="Ver gráfica" />
          <Card link="/configuracion" title="Configuración" desc="Categorías, cuentas y valuadores." btn="Abrir" />
        </div>

        <div className="mt-8 text-sm text-gray-500">
          * Se consideran montos pendientes y ajuste a viernes cuando un pago cae en fin de semana.
        </div>
      </div>
    </div>
  );
}

function Card({ link, title, desc, btn }) {
  return (
    <div className="rounded-xl border shadow-sm p-5 hover:shadow-md transition">
      <div className="text-worthblue font-bold text-xl mb-1">{title}</div>
      <p className="text-gray-600 text-sm mb-4">{desc}</p>
      <Link
        to={link}
        className="inline-block bg-worthblue text-white px-4 py-2 rounded font-semibold hover:bg-worthgold transition"
      >
        {btn}
      </Link>
    </div>
  );
}
